const buildQueryParamsFuncs = require('./src/buildQueryParams');
const doesPropExistAndHasItChangedFuncs = require('./src/doesPropExistAndHasItChanged');
const doesUserCustomRoleHaveAccessToFeatureFuncs = require('./src/doesUserCustomRoleHaveAccessToFeature');
const mappersFuncs = require('./src/mappers');
const currencyToolsFuncs = require('./src/currencies');
const countryToCurrencyMapperFuncs = require('./src/countryToCurrencyMapper');
const gatewayMapperFuncs = require('./src/gateways/gatewayMapper');
const gatewayPropertiesFuncs = require('./src/gateways/gatewayProperties');
const asyncGatewaysFuncs = require('./src/gateways/asyncGateways');
const apmsMapperFuncs = require('./src/apms/apmsMapper');
const stringFuncs = require('./src/string');
const dataTransformsFuncs = require('./src/dataTransforms');
const countryListFuncs = require('./src/countryList');
const changeLogMapperFuncs = require('./src/changeLog/changeLogMapper');
const webhooksFuncs = require('./src/webhooks');

//This file is made this way to improve cleanliness of test code using this utility.

module.exports = {
    getDisputeByDate: dataTransformsFuncs.getDisputeByDate,
    cycleTypes: mappersFuncs.cycleTypes,
    mapType: mappersFuncs.mapType,
    accountUpdaterModes: mappersFuncs.accountUpdaterModes,
    accountUpdaterModesMapper: mappersFuncs.accountUpdaterModesMapper,
    findProcessorWithMatchingPrefix: mappersFuncs.findProcessorWithMatchingPrefix,
    processorPrefixes: mappersFuncs.processorPrefixes,
    createQueryParams: buildQueryParamsFuncs.createQueryParams,
    doesPropExistAndHasItChanged: doesPropExistAndHasItChangedFuncs.doesPropExistAndHasItChanged,
    doesUserCustomRoleHaveAccessToFeature: doesUserCustomRoleHaveAccessToFeatureFuncs.doesUserCustomRoleHaveAccessToFeature,
    cardTypes: mappersFuncs.cardTypes,
    cardTypesMapper: mappersFuncs.cardTypesMapper,
    cardClasses: mappersFuncs.cardClasses,
    cardClassesMapper: mappersFuncs.cardClassesMapper,
    gatewayType: gatewayMapperFuncs.gatewayType,
    gatewaysThatCanRefund: gatewayPropertiesFuncs.gatewaysThatCanRefund,
    gatewaysThatCanVoid: gatewayPropertiesFuncs.gatewaysThatCanVoid,
    gatewaysThatCanCapture: gatewayPropertiesFuncs.gatewaysThatCanCapture,
    gatewayTypeMapper: gatewayMapperFuncs.gatewayTypeMapper,
    asyncGatewayList: asyncGatewaysFuncs.asyncGatewayList,
    gatewayAndApmMapper: gatewayMapperFuncs.gatewayAndApmMapper,
    gatewayAndApmType: gatewayMapperFuncs.gatewayAndApmType,
    gatewayInterfaceType: gatewayMapperFuncs.gatewayInterfaceType,
    gatewayLabelUpdate: gatewayMapperFuncs.gatewayLabelUpdate,
    cardVerificationProviderGatewayType: gatewayMapperFuncs.cardVerificationProviderGatewayType,
    cardVerificationProviderGatewayTypeMapper: gatewayMapperFuncs.cardVerificationProviderGatewayTypeMapper,
    slyceGatewayType: gatewayMapperFuncs.slyceGatewayType,
    apmType: apmsMapperFuncs.apmType,
    apmTypeMapper: apmsMapperFuncs.apmTypeMapper,
    apmLabelUpdate: apmsMapperFuncs.apmLabelUpdate,
    installmentProvidersMapper: mappersFuncs.installmentProvidersMapper,
    installmentProviders: mappersFuncs.installmentProviders,
    kountThresholds: mappersFuncs.kountThresholds,
    merchantProcessorType: mappersFuncs.merchantProcessorType,
    merchantProcessorTypeMapper: mappersFuncs.merchantProcessorTypeMapper,
    processorsWithDisputeEnabled: mappersFuncs.processorsWithDisputeEnabled,
    processMethod: mappersFuncs.processMethod,
    processMethodMapper: mappersFuncs.processMethodMapper,
    threeDSType: mappersFuncs.threeDSType,
    threeDSTypeMapper: mappersFuncs.threeDSTypeMapper,
    transactionStatus: mappersFuncs.transactionStatus,
    transactionStatusMapper: mappersFuncs.transactionStatusMapper,
    transactionType: mappersFuncs.transactionType,
    transactionTypeMapper: mappersFuncs.transactionTypeMapper,
    pluginType: mappersFuncs.pluginType,
    pluginTypeMapper: mappersFuncs.pluginTypeMapper,
    getDaysToDisputeChargeback: mappersFuncs.getDaysToDisputeChargeback,
    getCurrencyCode: stringFuncs.getCurrencyCode,
    luhnCheck: stringFuncs.luhnCheck,
    isValidCreditCard: stringFuncs.isValidCreditCard,
    maskNumber: stringFuncs.maskNumber,
    maskEmbeddedCardNumber: stringFuncs.maskEmbeddedCardNumber,
    setIf: stringFuncs.setIf,
    prettifyMoney: stringFuncs.prettifyMoney,
    prettifyNumber: stringFuncs.prettifyNumber,
    prettifyDateTimeV2: stringFuncs.prettifyDateTimeV2,
    reasonCodes: mappersFuncs.reasonCodes,
    paymentMethodToGateway: mappersFuncs.paymentMethodToGateway,
    gatewayToPaymentMethodMapper: mappersFuncs.gatewayToPaymentMethodMapper,
    currencyToGateway: mappersFuncs.currencyToGateway,
    gatewayToCurrencyMapper: mappersFuncs.gatewayToCurrencyMapper,
    currencyToApm: mappersFuncs.currencyToApm,
    apmToCurrencyMapper: mappersFuncs.apmToCurrencyMapper,
    countryToCurrency: countryToCurrencyMapperFuncs.countryToCurrencyList,
    paymentMethodsFormatted: mappersFuncs.paymentMethodsFormatted,
    chargebackCycleTypes: mappersFuncs.chargebackCycleTypes,
    chargebackCycleTypesMapper: mappersFuncs.chargebackCycleTypesMapper,
    fraudMapper: mappersFuncs.fraudMapper,
    fraudStatuses: mappersFuncs.fraudStatuses,
    dataTransform: dataTransformsFuncs.dataTransform,
    countryList: countryListFuncs.countryList,
    batchStatusMapper: mappersFuncs.batchStatusMapper,
    batchStatus: mappersFuncs.batchStatus,
    currency: currencyToolsFuncs.currency,
    currencyMapper: currencyToolsFuncs.currencyMapper,
    isCurrencyPrecisionValid: currencyToolsFuncs.isCurrencyPrecisionValid,
    getPreciseAmount: currencyToolsFuncs.getPreciseAmount,
    getMinimumUnitForCurrency: currencyToolsFuncs.getMinimumUnitForCurrency,
    convertCurrencyFromMinimumUnit: currencyToolsFuncs.convertCurrencyFromMinimumUnit,
    transactionStatusChangeSource: mappersFuncs.transactionStatusChangeSource,
    usageTypesMapper: mappersFuncs.usageTypesMapper,
    usageTypes: mappersFuncs.usageTypes,
    chargebackSource: mappersFuncs.chargebackSource,
    webhookEnabledGateways: mappersFuncs.webhookEnabledGateways,
    accountUpdaterUpdateTypesMapper: mappersFuncs.accountUpdaterUpdateTypesMapper,
    accountUpdaterUpdateTypes: mappersFuncs.accountUpdaterUpdateTypes,
    changeLogRecordType: changeLogMapperFuncs.changeLogRecordType,
    paymentSubTypes: mappersFuncs.paymentSubTypes,
    paymentSubTypesMapper: mappersFuncs.paymentSubTypesMapper,
    apmSubTypes: mappersFuncs.apmSubTypes,
    apmSubTypesMapper: mappersFuncs.apmSubTypesMapper,
    payoutSubTypes: mappersFuncs.payoutSubTypes,
    payoutSubTypesMapper: mappersFuncs.payoutSubTypesMapper,
    determineCardType: stringFuncs.determineCardType,
    paymentStatusToTransactionStatus: mappersFuncs.paymentStatusToTransactionStatus,
    paymentRecoveryProviderTypes: mappersFuncs.paymentRecoveryProviderTypes,
    paymentRecoveryProviderTypesMapper: mappersFuncs.paymentRecoveryProviderTypesMapper,
    paymentRecoveryStatusTypes: mappersFuncs.paymentRecoveryStatusTypes,
    paymentRecoveryStatusTypesMapper: mappersFuncs.paymentRecoveryStatusTypesMapper,
    processingOptionsPaymentTypes: mappersFuncs.processingOptionsPaymentTypes,
    processingOptionsPaymentTypesMapper: mappersFuncs.processingOptionsPaymentTypesMapper,
    retryEngineTypes: mappersFuncs.retryEngineTypes,
    retryEngineTypesMapper: mappersFuncs.retryEngineTypesMapper,
    accountAgreementStatus: mappersFuncs.accountAgreementStatus,
    accountTypes: mappersFuncs.accountTypes,
    payoutProvider: mappersFuncs.payoutProvider,
    payoutProviderMapper: mappersFuncs.payoutProviderMapper,
    payoutStatus: mappersFuncs.payoutStatus,
    payoutStatusMapper: mappersFuncs.payoutStatusMapper,
    transferStatus: mappersFuncs.transferStatus,
    transferStatusMapper: mappersFuncs.transferStatusMapper,
    spendbackStatus: mappersFuncs.spendbackStatus,
    spendbackStatusMapper: mappersFuncs.spendbackStatusMapper,
    achDetailType: mappersFuncs.achDetailType,
    achDetailTypeMapper: mappersFuncs.achDetailTypeMapper,
    webhookEventTypes: webhooksFuncs.webhookEventTypes,
    resellerMapper: mappersFuncs.resellerMapper,
    reseller: mappersFuncs.reseller,
    merchantApplicationSourceType: mappersFuncs.merchantApplicationSourceType,
    merchantApplicationSourceTypeMapper: mappersFuncs.merchantApplicationSourceTypeMapper
};
